module.exports = __webpack_public_path__ + "static/media/cepas.4c34536e.png";